const mFeedSectionContentCardEditionDesign7 = {
  mFeedSectionContentCardEditionDesign7: {
    buttonImage: 'Cambiar Imagen',

    infoPrice: {
      buy: 'COMPRAR',
      free: 'GRATIS',
      noprice: 'SIN PRECIO'
    },

    messages: {
      dimensions: '* Tamaño sugerido de imagen: 389px de ancho por 380px de alto',
      extensions: '* Formatos permitidos de imagen: .gif .jpg .png',
      nameLength: '* Longitud permitida de nombre: de 5 a 120 caracteres'
    },

    validation: {
      fileExtension: 'Extensión de imagen no permitida.',
      fileSize: 'Tamaño de imagen no permitido.',
      fileRequired: 'Imagen de tarjeta es requerida.',

      nombre: {
        maxLength: 'La longitud máxima permitida de nombre es de 120 caracteres.',
        minLength: 'La longitud mínima permitida de nombre es de 5 caracteres.',
        required: 'Nombre de producto es requerido. De 5 a 120 caracteres.'
      }
    }
  }
}

export default mFeedSectionContentCardEditionDesign7
